<template>
  <v-container>
    <v-list three-line>
        <template v-for="item in items">
            <v-list-item :key="item._id" >
                <v-list-item-avatar>
                    <img v-if="item.avatar" :src="item.avatar"/>
                    <img v-else src='@/assets/avatar_default.png'/>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title v-html="item.title"></v-list-item-title>
                    <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider :key="item.id"> </v-divider>
        </template>
    </v-list>

     <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="text-center pt-2">
        <v-btn color="primary" @click="nextPage"> Tải thêm </v-btn>
    </div>
  </v-container>
</template>

<script>
    import moment from 'moment';
    export default {
        data: () => ({
            baseImage: process.env.VUE_APP_BASE_IMAGE,
            baseAttach: process.env.VUE_APP_BASE_ATTACH,

            userType: parseInt(localStorage.getItem('type')),
            userID: localStorage.getItem('user_id'),

            limit: 20,
            page: 0,

            overlay: false,

            items: [],
        }),

        created() {
            this.getEventLog(true);
        },

        methods: {
            nextPage() {
                this.page = this.page + 1;
                this.getEventLog(false);
            },

            async getEventLog(refresh) {
                if (refresh) {
                    this.items = [];
                    this.page = 0;
                }

                self.overlay = true;
                
                var response;
                if (this.userType == 4) {//logistic  
                    response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'logistic/' + '?limit=' + this.limit + '&skip=' + this.page * this.limit);
                    console.log(response);
                } else if (this.userType == 3) {//accountant
                    response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'accountant/' + '?limit=' + this.limit + '&skip=' + this.page * this.limit);
                    console.log(response);
                } else if (this.userType == 2 || this.userType == 1) {
                    response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'targetUser/' + this.userID + '?limit=' + this.limit + '&skip=' + this.page * this.limit);
                    console.log(response);
                }
                // this.avatar = this.baseImage + this.user.avatar + "/50/50";
                self.overlay = false;

                if (response.data.success) {
                    var results = response.data.data;
                    
                    results.forEach(result => {
                        var event = {};
                        if (result.userRequest.avatar) {
                            event.avatar = this.baseImage + result.userRequest.avatar + "/50/50";
                        }
                        
                        event.title = result.content ? result.content : '';
                        event._id = result._id;                   
                        var time = moment(String(result.createdAt)).format("DD/MM/YYYY")
                        var type = parseInt(result.type);
                        if (type === 0) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã gửi YCTK mới cho bạn' : '';
                        } else if (type === 1) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã gửi YCTK mới cho bạn' : '';
                        } else if (type === 2) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã gửi YCSX mới cho bạn' : '';
                        } else if (type === 3) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã chỉnh sửa thông tin YCSX' : '';
                        } else if (type === 4) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; YCSX đã hoàn thành' : '';
                        } else if (type === 5) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã gửi YC ship mới cho bạn' : '';
                        } else if (type === 6) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Vận chuyển thành công đơn hàng' : '';
                        } else if (type === 7) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Vận chuyển thất bại đơn hàng' : '';
                        } else if (type === 8) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã duyệt đơn hàng' : '';
                        } else if (type === 9) {
                            event.subtitle = result.userRequest ? '<span class="text--primary">' + time + ' - ' + result.userRequest.fullname + '(' + result.userRequest.nickname + ')' + '</span> &mdash; Đã duyệt đơn hàng' : '';
                        }
                        
                        this.items.push(event);
                    });
                }
            }
        }
    }
</script>